import Dispatcher from '../dispatcher';
import 'babel-polyfill';

const TransactionStore = {

  _state: undefined,
  isLoading: false,
  refunding: false,

  init: function(){
    Dispatcher.on(Dispatcher.TRANSACTION_REQUEST_REFUND, (data)=>{ this._requestRefund(data); });
  },

  _requestRefund(details){
    if (!this.refunding) {
      this.refunding = true;
      Jigsaw.User.requestRefund(details, (response) => {
        let codes = details.codes;
        if(response.isSuccess()){
          if (response.data) {
            const {refund, purchase} = response.data;
            let newState = this._state;

            if (refund) {
              newState.unshift(refund);
            }

            if (purchase) {
              const oldTransaction = this._state.find( t => t.number === purchase.number);
              newState[newState.indexOf(oldTransaction)] = purchase;
            }

            this._updateState(newState);
          } else {
            this._load(true);
          }
          Dispatcher.emit(Dispatcher.TRANSACTION_REFUND_SUCCESS, { codes });
        }else{
          let data = response.data;
          data.itemCodes = details.codes;
          Dispatcher.emit(Dispatcher.TRANSACTION_REFUND_FAILURE, data);
        }
        this.refunding = false;
      });
    }
  },

  _updateState: function(state){
    this._state = state;
    Dispatcher.emit(Dispatcher.TRANSACTION_STORE_CHANGE);
  },

  _flatPurchaseItems: function() {
    let items = this._state.map((t) => {
      return t.purchaseItems;
    });

    // flatten into a one-dimensional array
    return [].concat.apply([], items);
  },

  get: function(id) {
    this._load();
    if(!this._state){ return undefined; }

    return (
      this._state.find((t) => {
        return t.number === id;
      }) || null
    );
  },

  getItem: function(number, isbn) {
    this._load();
    if(this._state === undefined){ return undefined; }

    return (
      this._state.find((t) => t.number === number)
      .purchaseItems.find((i) => i.isbn === isbn)
    );
  },

  getAll: function(){
    this._load();
    // return this._state;
    if(this._state){
      const purchases = [], refunds = [];
      this._state.forEach(t => {
        (parseFloat(t.total) >= 0 ? purchases : refunds).push(t);
      });
      return { purchases, refunds };
    }
  },

  getAllRefunds: function(){
    this._load();
    if(this._state){
      return this._state.filter((t)=>{
        return parseFloat(t.total) < 0;
      });
    }
  },

  getRefundedItems: function() {
    this._load();
    if(this._state === undefined){ return undefined; }

    return this._flatPurchaseItems().filter((i)=>{
      return i.refunded === true;
    });
  },

  _load: function(update){
    if (!this.isLoading && (update || !this._state)){
      this.isLoading = true;
      Jigsaw.User.getAllTransactions(function(response){
        if (response.isSuccess()){
          this._updateState(response.data.transactions);
          Jigsaw.addEvents([{
            name: 'MulliganTransactionCount',
            count: response.data.transactions.length
          }]);
        }else{
          this._updateState([]);
        }
        this.isLoading = false;
      }.bind(this));
    }
  }

};

TransactionStore.init();
export default TransactionStore;
